<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA DE UBICACIÓN</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container mat-elevation-z2" tabindex="0">
            <div class="table-adjustable">
                <table
                    mat-table
                    [dataSource]="
                        (asyncAddress | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let address">
                            <div class="action-buttons">
                                <a
                                    (click)="updateAddress(address)"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>edit</mat-icon></span
                                    >
                                </a>
                                <a
                                    (click)="eliminate(address)"
                                    appOnlysuperuser="/address"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>delete</mat-icon></span
                                    >
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="outsider">
                        <th mat-header-cell *matHeaderCellDef>Usuario</th>
                        <td mat-cell *matCellDef="let address">
                            {{ address.outsider?.identificationCode }}-{{
                                address.outsider?.name
                            }}
                            {{ address.outsider?.lastName }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="authorityCode">
                        <th mat-header-cell *matHeaderCellDef>
                            Código de autoridad
                        </th>
                        <td mat-cell *matCellDef="let address">
                            {{ address.authorityCode }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="authority">
                        <th mat-header-cell *matHeaderCellDef>Autoridad</th>
                        <td mat-cell *matCellDef="let address">
                            {{ address.authority }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="territoryCode">
                        <th mat-header-cell *matHeaderCellDef>
                            Código de territorio
                        </th>
                        <td mat-cell *matCellDef="let address">
                            {{ address.territoryCode }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="territory">
                        <th mat-header-cell *matHeaderCellDef>Territorio</th>
                        <td mat-cell *matCellDef="let address">
                            {{ address.territory }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Dirección</th>
                        <td mat-cell *matCellDef="let address">
                            {{ address.street }} {{ address.number }}
                            {{ address.complement }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="geoRef">
                        <th mat-header-cell *matHeaderCellDef>
                            Georreferenciación
                        </th>
                        <td mat-cell *matCellDef="let address">
                            <a
                                class="enlace"
                                href="https://maps.google.com/?q={{
                                    address.geoRef?.latitude
                                }},{{ address.geoRef?.longitude }}"
                                target="_blank"
                            >
                                {{ address.geoRef?.latitude }},
                                {{ address.geoRef?.longitude }}
                            </a>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="fetchAddress($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
